import React from "react";

export const TemplateTypeBadge = ({ type }) => {
  const styles = {
    base: "bg-accent-green/10 text-accent-green",
    custom: "bg-severity-medium/10 text-severity-medium",
    customized_base: "bg-accent-purple/10 text-accent-purple",
  };
  const labels = { base: "Base", custom: "Custom", customized_base: "Customized" };
  return (
    <span className={`px-2 py-0.5 rounded-md text-body-xs font-medium ${styles[type] || "bg-surface-neutral-subtle text-text-secondary"}`}>
      {labels[type] || type}
    </span>
  );
};

export const PlanBadge = ({ plan }) => {
  const styles = {
    core: "bg-surface-neutral-subtle text-text-secondary",
    premium: "bg-accent-purple/10 text-accent-purple",
  };
  return (
    <span className={`px-2 py-0.5 rounded-md text-body-xs font-medium ${styles[plan] || "bg-surface-neutral-subtle text-text-secondary"}`}>
      {plan?.toUpperCase()}
    </span>
  );
};

export const SyncBadge = ({ syncStatus }) => {
  if (!syncStatus) return null;
  if (!syncStatus.staging_exists) {
    return <span className="px-2 py-0.5 rounded-md text-caption font-medium bg-severity-medium/10 text-severity-medium">Prod Only</span>;
  }
  if (!syncStatus.prod_exists) {
    return <span className="px-2 py-0.5 rounded-md text-caption font-medium bg-accent-purple/10 text-accent-purple">Staging Only</span>;
  }
  if (syncStatus.in_sync) {
    return <span className="px-2 py-0.5 rounded-md text-caption font-medium bg-accent-green/10 text-accent-green">In Sync</span>;
  }
  return <span className="px-2 py-0.5 rounded-md text-caption font-medium bg-severity-high/10 text-severity-high">Out of Sync</span>;
};

const SCAN_MODE_CONFIG = {
  scraper_one_look: { label: "Scraper", style: "bg-accent-purple/10 text-accent-purple" },
  agentic_test: { label: "Agentic", style: "bg-accent-pink/10 text-accent-pink" },
  agentic_test_definition: { label: "Discovery", style: "bg-severity-medium/10 text-severity-medium" },
  broken_link: { label: "Links", style: "bg-severity-high/10 text-severity-high" },
  broken_image: { label: "Images", style: "bg-severity-high/10 text-severity-high" },
};

export const ScanModeBadge = ({ mode }) => {
  const config = SCAN_MODE_CONFIG[mode] || { label: mode, style: "bg-surface-neutral-subtle text-text-secondary" };
  return (
    <span className={`px-2 py-0.5 rounded-md text-body-xs font-medium ${config.style}`}>
      {config.label}
    </span>
  );
};
